import moment from 'moment'

export function normalizeDate(date) {
  return moment(date).format('DD/MM/YYYY')
}
